var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolyGridRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 309,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#poly-grid-right_svg__clip0_6539_2609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.911 2L58.408 14.2M119.911 2L65.406 58.587M119.911 2l-18.924 105M119.911 2L203 132.892M58.408 14.2l6.998 44.387M58.408 14.2l-14.82 15.637m21.818 28.75l-21.819-28.75m21.82 28.75L27.79 71.389m37.615-12.802L100.987 107m-35.58-48.413L63.012 84.64M100.987 107L63.013 84.641M100.987 107l-25.968 29.695M100.987 107L203 132.892m0 0l-62.86 125.467M203 132.892l-102.013 108.92m-57.4-211.976L27.791 71.39m0 0l35.222 13.252M27.791 71.39l21.221 43.406m14.001-30.154l-14.001 30.154m14.001-30.154l12.006 52.054m-26.007-21.9L2 148.921m73.02-12.226L2 148.921m73.02-12.226l-8.098 75.637M2 148.921l21.124 63.411M2 148.921l64.922 63.411m0 0l11.608 34.366m-11.608-34.366H23.124m117.016 46.027l-22.599 21.525m22.599-21.525l-39.153-16.547m0 0l16.554 38.072m-16.554-38.072l-22.457 4.886m39.011 33.186L54.661 307m0 0l23.869-60.302M54.66 307l-25.353-46.545-6.183-48.123M54.661 307l-6.919-50.05m30.788-10.252L47.742 256.95m30.788-10.252l-18.414-23.334-36.992-11.032m0 0l24.618 44.618",
    stroke: "url(#poly-grid-right_svg__paint0_linear_6539_2609)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poly-grid-right_svg__paint0_linear_6539_2609",
    x1: 184.255,
    y1: 151.111,
    x2: 134.57,
    y2: 151.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f2a7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "poly-grid-right_svg__clip0_6539_2609"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h205v309H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyGridRight);
export default __webpack_public_path__ + "static/media/poly-grid-right.f85481b2a396298a399cb10941059133.svg";
export { ForwardRef as ReactComponent };